import { createAction } from 'redux-actions';

export const socketsStoreInitNotificationsAction = createAction('SOCKETS/INIT_NOTIFICATIONS');
export const socketsStoreNewNotificationAction = createAction('SOCKETS/STORE_NEW_NOTIFICATION');
